module.exports = __webpack_public_path__ + "static/img/ruanjianchanpin_houtai.ae61ed6f.png";